module.exports = __webpack_public_path__ + "img/big.4b1a59d9.jpg";